module.exports = __webpack_public_path__ + "img/sc_app@2x.24d5a1c7.png";